import React from "react";

const DashboardIcon = (props) => {
  return (
    <svg
      {...props}
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="none"
        d="M15 9.94678H10C9.44772 9.94678 9 10.3945 9 10.9468V17.9468C9 18.4991 9.44772 18.9468 10 18.9468H15C15.5523 18.9468 16 18.4991 16 17.9468V10.9468C16 10.3945 15.5523 9.94678 15 9.94678Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M26 9.94678H21C20.4477 9.94678 20 10.3945 20 10.9468V13.9468C20 14.4991 20.4477 14.9468 21 14.9468H26C26.5523 14.9468 27 14.4991 27 13.9468V10.9468C27 10.3945 26.5523 9.94678 26 9.94678Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M26 18.9468H21C20.4477 18.9468 20 19.3945 20 19.9468V26.9468C20 27.4991 20.4477 27.9468 21 27.9468H26C26.5523 27.9468 27 27.4991 27 26.9468V19.9468C27 19.3945 26.5523 18.9468 26 18.9468Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill="none"
        d="M15 22.9468H10C9.44772 22.9468 9 23.3945 9 23.9468V26.9468C9 27.4991 9.44772 27.9468 10 27.9468H15C15.5523 27.9468 16 27.4991 16 26.9468V23.9468C16 23.3945 15.5523 22.9468 15 22.9468Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DashboardIcon;
